import { css } from '@emotion/css';

export const getStyles = () => ({
  button: css`
    position: absolute;
    right: 10px;
    top: 10px;
    outline: none;
    margin: 0;
  `,
});
